//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// @ is an alias to /src
import { mapState } from 'vuex'
export default {
  name: 'UsersList',
  data() {
    return {
      orders: [],
      list: []
    }
  },
  components: {
  },
  computed: mapState({
    user: state => state.user.user
  }),
  mounted() {
    this.getUsersByOpenId()
  },
  methods: {
    getUsersByOpenId () {
      this.$store.httpDispatch({})('getUsersByOpenId', {
        openid: this.$route.query.openid
      })
      .then((res) => {
        if (res.data.code === 0) {
          this.list = res.data.data.users
          this.orders = this.list[0] ? this.list[0].orders : []
        }
      })
    }
  }
}
